import {memo} from 'react';
import {Card, CardBody} from "@material-tailwind/react";
import TitleWithInfoTooltip from "./TitleWithInfoTooltip";

interface DashboardCardProps {
    name: string,
    count: string
    icon: JSX.Element,
    color: string,
    tooltip?: string,
}
const DashboardCard = ({name, color, count, icon, tooltip}: DashboardCardProps) => {
    const iconColor = color.length > 0 ? color : 'text-orange-400';
    return (
        <Card className="bg-white dark:bg-blue-gray-900 dark:text-gray-500 mb-4 md:mb-0">
            <CardBody className="p-4 md:p-5 flex items-start gap-3 md:gap-4">
                {/* tile tinted with the card's own text colour */}
                <span className={`${iconColor} relative shrink-0 inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg`}>
                    <span className="absolute inset-0 rounded-lg bg-current opacity-10"/>
                    {icon}
                </span>
                <div className="min-w-0">
                    <TitleWithInfoTooltip
                        title={name}
                        tooltip={tooltip}
                        className="text-xs md:text-sm font-medium text-blue-gray-500 dark:text-blue-gray-300"
                        tooltipPlacement="top"
                    />
                    <div className="mt-1 text-lg md:text-2xl font-semibold tracking-tight text-blue-gray-900 dark:text-white break-words">{count}</div>
                </div>
            </CardBody>
        </Card>
    );
}

export default memo(DashboardCard);
